import { ButtonHTMLAttributes, ReactNode } from 'react';
import { Spinner } from '../Spinner';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  isLoading?: boolean;
  variant?: 'primary' | 'secondary';
}

export function Button({
  children,
  isLoading,
  variant = 'primary',
  disabled,
  className = '',
  style,
  ...props
}: ButtonProps) {
  const baseClasses = 'px-4 py-2 rounded font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

  const variantStyle =
    variant === 'primary'
      ? { backgroundColor: '#1e3a3a', color: '#e8ecf4' }
      : { backgroundColor: '#1a1e28', color: '#b0b8c8', border: '1px solid #1e2430' };

  const hoverClass =
    variant === 'primary'
      ? 'hover:bg-[#2a4a4a]'
      : 'hover:bg-[#242a38]';

  return (
    <button
      className={`${baseClasses} ${hoverClass} ${className}`}
      style={{ ...variantStyle, ...style }}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <span className="flex items-center justify-center gap-2">
          <Spinner size="sm" />
          Loading...
        </span>
      ) : (
        children
      )}
    </button>
  );
}
